export default "__VITE_ASSET__Ctf5zWGH__"